import React from 'react'
// import PropTypes from 'prop-types'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import { MainTitle, Subtitle, HighlightText, TextContent, JsonCodeStyle } from '../../../Shared';
import { StyledTableCell, StyledTableRow, useTableStyles } from '../../styles/Table.styled';
import { StyledSeparated } from './UserRegister.styled';

function createData(fields, type, description) {
  return { fields, type, description };
}

const listDataSchema = [
  createData('_id','string',''),
  createData('user','string',''),
  createData('username','string','unique field'),
  createData('status','string','active or disabled'),
  createData('type','string','password'),
  createData('createdAt','date',''),
  createData('updatedAt','date',''),
  createData('evaluation_score','number','reputation score of user'),
  createData('evaluation_count','number','total evaluation times of user'),

];

const UserRegister = props => {
  const classes = useTableStyles();

  const requestData = {
    "username": "string",
    "password": "string",
    "name": "string",
    "email": "string",
    "avatar": "string",
    "phone": "string"
  };

  const responseSuccess = {
    "code": 200,
    "message": "success",
    "data": {
        "_id": "5f8b1255fd75bf3cf2b17bf3",
        "user": "5f8b1255fd75bf3cf2b17bf2",
        "username": "khanhtran12",
        "status": "active",
        "type": "password",
        "createdAt": "2020-10-17T15:48:37.891Z",
        "updatedAt": "2020-10-17T15:48:37.891Z",
        "__v": 0
    }
  };

  const duplicateUsername = {
    "code": 400,
    "message": "Bad input parameter",
    "errors": [
      {
        "reason": "duplicated",
        "message": "Field existed",
        "domain": "username"
      }
    ]
  }

  const validationWrongInput = {
    "code": 400,
    "message": "Bad input parameter",
    "errors": [
      {
        "reason": "invalid",
        "message": "\"email\" must be a valid email",
        "domain": "email"
      }
    ]
  }

  return (
    <div>
      <MainTitle>User Register</MainTitle>
      <Subtitle id="data-schema-1">1. Data Schema</Subtitle>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Code</StyledTableCell>
              <StyledTableCell align="left">Message</StyledTableCell>
              <StyledTableCell align="left">Detail</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {listDataSchema.map((row) => (
              <StyledTableRow key={row.fields}>
                <StyledTableCell>
                  {row.fields}
                </StyledTableCell>
                <StyledTableCell align="left">{row.type}</StyledTableCell>
                <StyledTableCell component="th" scope="row" align="left">{row.description}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Subtitle id="request-2">2. Request</Subtitle>
      <TextContent><b><i>URI: </i></b><HighlightText>/api/auth/register</HighlightText> </TextContent>
      <TextContent><b><i>Method </i></b>@POST</TextContent>
      <TextContent><b><i>Request Data</i></b></TextContent>
      <JsonCodeStyle data={requestData} />

      <Subtitle id="response-3">3. Response</Subtitle>

      <Subtitle isSmall id="a-success">a. Success</Subtitle>
      <JsonCodeStyle data={responseSuccess} />

      <Subtitle isSmall id="b-errors">b. Errors</Subtitle>
      <TextContent>&nbsp;&nbsp; 1. Duplicate user name</TextContent>
      <JsonCodeStyle data={duplicateUsername} />

      <TextContent>&nbsp;&nbsp; 2. Validation wrong input</TextContent>
      <TextContent>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; This is one of this type.</TextContent>
      <JsonCodeStyle data={validationWrongInput} />
      <StyledSeparated />
    </div>
  )
}

UserRegister.propTypes = {

}

export default UserRegister
